import { render, staticRenderFns } from "./menberData.vue?vue&type=template&id=48685840&scoped=true"
import script from "./menberData.vue?vue&type=script&lang=js"
export * from "./menberData.vue?vue&type=script&lang=js"
import style0 from "./menberData.vue?vue&type=style&index=0&id=48685840&prod&lang=less&scoped=true"
import style1 from "./menberData.vue?vue&type=style&index=1&id=48685840&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48685840",
  null
  
)

export default component.exports